import { useCallback } from 'react';

import { ICartEntry, ISanityVendorConfigs } from '@rbi-ctg/menu';

import { useCartEntriesMenuObjects } from './use-cart-entries-menu-objects';

export const useGetMenuItemVendorConfigForCartEntries = () => {
  const { getCartEntriesMenuObjects } = useCartEntriesMenuObjects();
  return useCallback(
    async (cartEntries: ICartEntry[]) => {
      const cartEntriesMenuObjects = await getCartEntriesMenuObjects(cartEntries);

      const items = cartEntriesMenuObjects.reduce(
        (acc: Record<string, ISanityVendorConfigs>, { data, entry }) => {
          const { vendorConfigs } = (data as { vendorConfigs: ISanityVendorConfigs }) ?? {};
          acc[entry._id] = vendorConfigs || entry.vendorConfigs;
          return acc;
        },
        {} as Record<string, ISanityVendorConfigs>
      );
      return { items };
    },
    [getCartEntriesMenuObjects]
  );
};
